(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bmj-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bmj-announcement')) {
    customElements.define('bmj-announcement', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-block-id]')];
        this.index = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.addEventListener('click', event => {
          if (event.target.closest('a[href="#bmj-newsletter"]')) {
            const form = document.querySelector('.footer__newsletter form.newsletter-form');
            if (form) {
              event.preventDefault();
              form.scrollIntoView({ behavior: this.motion.matches ? 'auto' : 'smooth', block: 'center' });
            }
          }
          if (event.target.closest('a[href="#bmj-help"]')) {
            const helpButton = document.querySelector('button.link[aria-controls="HelpDrawer"]');
            if (helpButton) {
              event.preventDefault();
              helpButton.click();
            }
          }
          const action = event.target.closest('[data-action]')?.dataset.action;
          if (action === 'next' || action === 'previous') this.show(this.index + (action === 'next' ? 1 : -1));
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.schedule(); }, options);
        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', event => {
            const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
            if (index >= 0) this.show(index);
          }, options);
        }
        this.schedule();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || this.hidden || document.hidden || window.Shopify?.designMode) return;
        this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
